import PropTypes from 'prop-types'

import { cn } from '@/utils/helpers'

// "on-dark" is tuned for the primary-color CourseModal header (white text +
// translucent white track); "on-light" matches the rest of the app's
// surface treatments. Default is on-dark to preserve existing call sites.
const TONE = {
  'on-dark': { label: 'text-white/90', track: 'bg-white/20' },
  'on-light': { label: 'text-muted-foreground', track: 'bg-muted' },
}

function CourseProgressBar({ current, total, label = null, className = '', tone = 'on-dark' }) {
  const safeTotal = Math.max(total, 1)
  const safeCurrent = Math.min(Math.max(current, 0), safeTotal)
  const pct = Math.round((safeCurrent / safeTotal) * 100)
  const styles = TONE[tone] ?? TONE['on-dark']

  return (
    <div className={cn('flex w-full flex-col gap-1', className)}>
      <div className={cn('flex items-center justify-between text-xs', styles.label)}>
        <span className="font-medium">{label ?? `Module ${safeCurrent} of ${safeTotal}`}</span>
        <span className="tabular-nums" aria-hidden="true">
          {pct}%
        </span>
      </div>
      <div
        className={cn('h-1.5 w-full overflow-hidden rounded-full', styles.track)}
        role="progressbar"
        aria-valuenow={pct}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={`Course progress: ${pct} percent complete`}
      >
        <div
          className="bg-success h-full rounded-full transition-[width] duration-500 ease-out"
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  )
}

CourseProgressBar.propTypes = {
  current: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  label: PropTypes.node,
  className: PropTypes.string,
  tone: PropTypes.oneOf(['on-dark', 'on-light']),
}

export default CourseProgressBar
